import { Routes } from '@angular/router';
import { CtiWidgetComponent } from './components/cti-widget/cti-widget.component';
import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [
    {
        path: '',
        component: CtiWidgetComponent,
        title: 'CTI Widget',
        canActivate: [MsalGuard],
      },
      {
        path: '**',
        component: CtiWidgetComponent,
        canActivate: [MsalGuard],
      },
];
